import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import './StatCard.css';

interface StatCardProps {
  id: string;
  title: string;
  value: string;
  change: number;
  icon: React.ReactNode;
  color: string;
  gradient: string;
  darkMode: boolean;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, color, darkMode }) => {
  return (
    <Paper className={`stat-card ${darkMode ? 'dark' : 'light'}`} elevation={0}>
      <Box className="stat-body">
        <Box className="stat-text">
          <Typography variant="caption" className="stat-label">
            {title}
          </Typography>
          <Typography variant="h4" className="stat-value">
            {value}
          </Typography>
        </Box>
        <Box className="stat-icon-wrap" style={{ backgroundColor: `${color}18`, color }}>
          {icon}
        </Box>
      </Box>
    </Paper>
  );
};

export default StatCard;
